import React, { useEffect, useState } from 'react'
import classNames from 'classnames'
import { SelectInputProps } from './SelectInput.d'

const SelectInput = ({
  disabled,
  fullWidth,
  id,
  label,
  multiple,
  name,
  value,
  onChange,
  onBlur,
  options,
  required,
  error
}: SelectInputProps) => {
  const [selectedOptions, setSelectedOptions] = useState([])

  useEffect(() => {
    if (!selectedOptions.length && options.length && !multiple) {
      setSelectedOptions([options[0].value])
    }
  }, [options, multiple, selectedOptions])

  const selectStyles = classNames({
    // Base styles
    'bg-white text-gray-50 border border-gray-50 px-3 py-3 appearance-none rounded-none':
      true,
    // Transitions
    'transition-colors transition-shadow duration-300': true,
    // Focused styles
    'focus:outline-none focus:border-gray-50 focus:shadow-text-input focus:text-default':
      true,
    // Dropdown arrow, only on single select (not multiple)
    'bg-down-arrow-grey bg-no-repeat bg-[right_15px_bottom_16px]': !multiple,
    // Full Width
    'w-full': fullWidth,
    // Arrow down
    'bg-icon-down-arrow-gray bg-[right_1rem_bottom_1rem] ': true,
    // Error
    'border border-otl-error': error
  })

  const wrapperClass = classNames({
    'w-full': true,
    'mb-4 md:mb-0': error
  })

  const setDefaultValue = (): string | number | any[] => {
    if (multiple) return []
    if (options.filter((o) => o.selected)[0])
      return options.filter((o) => o.selected)[0].value
    return options[0].value
  }

  return (
    <div className={wrapperClass}>
      <select
        className={selectStyles}
        defaultValue={setDefaultValue()}
        disabled={disabled}
        id={id}
        multiple={multiple}
        name={name}
        onChange={onChange}
        onBlur={onBlur}
        required={required}
      >
        {options.map(
          ({ disabled: optionDisabled, value, label: optionLabel }) => {
            const optionStyles = classNames({
              'text-gray-50': optionDisabled
            })
            return (
              <option
                key={value}
                className={optionStyles}
                disabled={optionDisabled}
                value={value}
              >
                {optionLabel}
              </option>
            )
          }
        )}
      </select>
      <label htmlFor={id} className='sr-only'>
        {label}
      </label>
      {error && (
        <div
          role='alert'
          className='text-otl-error text-xs absolute top-13 left-0 whitespace-nowrap md:mb-3'
        >
          {error}
        </div>
      )}
    </div>
  )
}

export default SelectInput
